import { fetchDataByAsset } from './fetchDataByAsset';
import { fetchAiAppTrends, fetchSegmentTransitions } from './aiAppTrends';

import { aiDashboardAssets } from '../configs/constants';
import { isUnified, unifiedRefNoBy } from '../../../utils/helpers';

// Response transformers
const decorateAppsWithUnifiedRefNo = (apps) =>
  apps.map((app) => ({
    ...app,
    unified_ref_no: unifiedRefNoBy({ ...app, kind: isUnified(app) ? 'unified_app' : 'app' }),
  }));

const aiAppsTransformResponse = (data) => ({
  data: {
    apps: decorateAppsWithUnifiedRefNo(data?.ai_sector_apps || []),
    top_apps: decorateAppsWithUnifiedRefNo(data?.top_ai_sector_apps || []),
  },
});

export const fetchAiApps =
  ({ campaignEnded = false }) =>
  (dispatch, getState) => {
    dispatch(
      fetchDataByAsset(
        aiDashboardAssets.apps,
        {},
        {
          transformResponse: (data) => aiAppsTransformResponse(data),
          onSuccess: (responseData) => {
            // Fetch app dependent assets
            const { aiDashboard } = getState();
            const { filters: aiAppTrendsFilters } = aiDashboard[aiDashboardAssets.aiAppTrends];

            if (!aiAppTrendsFilters.app_uid) {
              const preselectedApp = responseData.data.top_apps?.[0];
              if (preselectedApp && !campaignEnded) {
                dispatch(fetchAiAppTrends({ app_uid: preselectedApp.unified_ref_no }));
                dispatch(fetchSegmentTransitions({ app_uid: preselectedApp.unified_ref_no }));
              }
            }
          },
        }
      )
    );
  };
